import globalStyles from '@findigs/ui-kit/src/css/global.scss?url';
import faviconDark from '@findigs/ui-kit/src/images/favicon-dark.ico';
import favicon from '@findigs/ui-kit/src/images/favicon.ico';
import faviconPng from '@findigs/ui-kit/src/images/favicon.png';
import type { LinksFunction } from '@remix-run/node';
import appStyles from '~/css/app.scss?url';
import faviconMaskSvg from '@findigs/ui-kit/src/images/favicon-mask.raw.svg';
import faviconSvg from '@findigs/ui-kit/src/images/favicon.raw.svg';

type LinkDescriptor = ReturnType<LinksFunction>[0];

export const getLinks = (cssBundleHref?: string | null): LinkDescriptor[] => [
  { rel: 'apple-touch-icon', href: faviconPng },
  { rel: 'mask-icon', href: faviconMaskSvg, color: '#212B14' },
  { rel: 'shortcut icon', href: favicon, sizes: 'any', type: 'image/x-icon' },
  {
    rel: 'shortcut icon',
    href: faviconDark,
    sizes: 'any',
    type: 'image/x-icon',
    media: '(prefers-color-scheme: dark)',
  },
  { rel: 'shortcut icon', href: faviconPng, sizes: 'any', type: 'image/png' },
  {
    rel: 'shortcut icon',
    href: faviconSvg,
    sizes: 'any',
    type: 'image/svg+xml',
  },
  { rel: 'stylesheet', href: globalStyles },
  { rel: 'stylesheet', href: appStyles },
  { rel: 'dns-prefetch', href: 'https://widget.usepylon.com' },
  { rel: 'preconnect', href: 'https://widget.usepylon.com' },
  ...(cssBundleHref ? [{ rel: 'stylesheet', href: cssBundleHref }] : []),
];

export function linksToString(links: LinkDescriptor[]): string {
  return links
    .map((link) => {
      const attributes = Object.entries(link)
        .map(([key, value]) => {
          return `${key}="${String(value)}"`;
        })
        .filter(Boolean)
        .join(' ');
      return `<link ${attributes}>`;
    })
    .join('\n');
}
